import { queryOptions } from '@tanstack/react-query';
import {
  fetchControls,
  fetchMistakes,
  fetchPlayWindow,
  fetchProgress,
  fetchFigureFailures,
  fetchReviewQueue,
  fetchWallet,
} from '../../lib/api';

/**
 * Усі серверні дані ходять через TanStack Query, а кеш лежить в IndexedDB.
 * Тому після F5 без мережі екрани показують останній відомий стан,
 * а не порожнечу — і при цьому жодне число не рахується на клієнті.
 */
export const walletQuery = (learnerId: string) =>
  queryOptions({
    queryKey: ['wallet', learnerId] as const,
    queryFn: ({ signal }) => fetchWallet(learnerId, signal),
    staleTime: 15_000,
  });

export const progressQuery = (learnerId: string, days = 30) =>
  queryOptions({
    queryKey: ['progress', learnerId, days] as const,
    queryFn: ({ signal }) => fetchProgress(learnerId, days, signal),
    staleTime: 60_000,
  });

/**
 * Стан перерви. Свіжість тут важить більше за економію запитів: екран
 * перерви має відпустити дитину рівно тоді, коли перерва скінчилась,
 * а не коли комусь заманеться перезавантажити сторінку.
 */
export const playWindowQuery = (learnerId: string) =>
  queryOptions({
    queryKey: ['play-window', learnerId] as const,
    queryFn: () => fetchPlayWindow(learnerId),
    staleTime: 10_000,
    refetchInterval: 30_000,
  });

export const mistakesQuery = (learnerId: string) =>
  queryOptions({
    queryKey: ['mistakes', learnerId] as const,
    queryFn: ({ signal }) => fetchMistakes(learnerId, signal),
    staleTime: 60_000,
  });

export const controlsQuery = (learnerId: string) =>
  queryOptions({
    queryKey: ['controls', learnerId] as const,
    queryFn: ({ signal }) => fetchControls(learnerId, signal),
    staleTime: 60_000,
  });

export const figureFailuresQuery = () =>
  queryOptions({
    queryKey: ['figure-failures'] as const,
    queryFn: ({ signal }) => fetchFigureFailures(signal),
    staleTime: 30_000,
  });

export const reviewQueueQuery = () =>
  queryOptions({
    queryKey: ['review-queue'] as const,
    queryFn: ({ signal }) => fetchReviewQueue(signal),
    staleTime: 30_000,
  });
